import React from 'react' //eslint-disable-line
import {
  BaseComponent
} from 'belle-js'

const withLoadingState = (Component, LoadingComponent) => {
  class Container extends BaseComponent {

    render () {
      const {
        loading
      } = this.props

      if (loading) {
        return LoadingComponent
      }
      return Component
    }

  }
  return Container
}

export default withLoadingState



// WEBPACK FOOTER //
// ./src/components/Client/withLoadingState.jsx